import {
  actors,
  contentItems,
  dramas,
  newsItems,
  type ContentItem,
  type ContentType,
} from "@/mocks/content";

export const typeLabel: Record<ContentType, string> = {
  drama: "剧情介绍",
  actor: "演员资料",
  news: "影视资讯",
};

export const typePath: Record<ContentType, string> = {
  drama: "/category/剧情介绍",
  actor: "/category/演员资料",
  news: "/category/影视资讯",
};

export function getContentById(id: string | undefined): ContentItem | undefined {
  if (!id) return undefined;
  return contentItems.find((item) => item.id === id);
}

export function getItemsByType(type: ContentType): ContentItem[] {
  return contentItems.filter((item) => item.type === type);
}

export function getRelatedItems(item: ContentItem, limit = 4): ContentItem[] {
  const sameType = contentItems.filter(
    (candidate) => candidate.id !== item.id && candidate.type === item.type,
  );
  const scored = sameType.map((candidate) => {
    const overlap = candidate.tags.filter((tag) => item.tags.includes(tag)).length;
    return { candidate, overlap };
  });
  scored.sort((a, b) => b.overlap - a.overlap);
  const related = scored.map((entry) => entry.candidate).slice(0, limit);
  if (related.length >= limit) return related;
  const fallback = contentItems.filter(
    (candidate) =>
      candidate.id !== item.id &&
      !related.some((picked) => picked.id === candidate.id),
  );
  return [...related, ...fallback].slice(0, limit);
}

export function searchContent(query: string, type?: ContentType | "all"): ContentItem[] {
  const keyword = query.trim().toLowerCase();
  if (!keyword) return [];
  return contentItems.filter((item) => {
    if (type && type !== "all" && item.type !== type) return false;
    const haystack = [
      item.title,
      item.subtitle,
      item.excerpt,
      item.tags.join(" "),
      item.body.map((section) => section.paragraphs.join(" ")).join(" "),
      item.type === "actor" ? item.role : "",
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(keyword);
  });
}

export function formatDate(value: string): string {
  const [year, month, day] = value.split("-");
  if (!year || !month || !day) return value;
  return `${year}年${Number(month)}月${Number(day)}日`;
}

export function countByType(): Record<ContentType, number> {
  return {
    drama: dramas.length,
    actor: actors.length,
    news: newsItems.length,
  };
}